// extracted by mini-css-extract-plugin
export default {"inputControl":"Input_inputControl__FXOdy","label":"Input_label__0ps2g","requiredMark":"Input_requiredMark__PgpKh","inputField":"Input_inputField__h4LoW"};